import Swiper, { Navigation, Pagination } from 'swiper/core';

Swiper.use([Navigation, Pagination]);

export const SetupSwiper = () => {
    
    const contentSliders = document.querySelectorAll('.slider');
    
    contentSliders.forEach((element) => {
      new Swiper(element, {
        slidesPerView: 1,
        pagination: {
          el: element.querySelector('.swiper-pagination'),
          bulletActiveClass: 'current',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
        navigation: {
          prevEl: element.querySelector('.swiper-button-prev'),
          nextEl: element.querySelector('.swiper-button-next')
        }
      })
    });
    
}